import React, { lazy, Suspense } from "react";
import { createBrowserHistory } from "history";
import { Route, Router, Switch } from "react-router-dom";

import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import ReactGA from "react-ga4";

import PageMiss from "./404/404";
import Loader from "./Utils/Loader/Loader";

import "./App.css";

const Home = lazy(() => import(/* webpackChunkName: "home" */ "./Home/Home"));
const Team = lazy(() => import(/* webpackChunkName: "team" */ "./Team/Team"));
const Faculty = lazy(() => import(/* webpackChunkName: "faculty" */ "./Faculty/Faculty"));
const Partners = lazy(() => import(/* webpackChunkName: "partners" */ "./Partners/Partners"));
const AbstractClosed = lazy(() => import(/* webpackChunkName: "abstract" */ "./Abstract/AbstractClosed"));
const AbstractForm = lazy(() => import(/* webpackChunkName: "abstract-form" */ "./Abstract/AbstractForm"));
const ScientificProgram = lazy(() => import(/* webpackChunkName: "scientific-program" */ "./ScientificProgram/ScientificProgram"));
const OrderSuccess = lazy(() => import(/* webpackChunkName: "order-success" */ "./OrderStatus/OrderSuccess"));
const OrderFail = lazy(() => import(/* webpackChunkName: "order-failed" */ "./OrderStatus/OrderFail"));
const Contact = lazy(() => import(/* webpackChunkName: "contact" */ "./Contact/Contact"));
const NearbyPlaces = lazy(() => import(/* webpackChunkName: "nearby-places" */ "./NearbyPlaces/NearbyPlaces"));
const Registration = lazy(() => import(/* webpackChunkName: "registration" */ "./Registration/Registration"));
const Industry = lazy(() => import(/* webpackChunkName: "industry" */ "./Reg-Routes/Industry"));
const IndustryAsDelegate = lazy(() => import(/* webpackChunkName: "industry-as-delegate" */ "./Reg-Routes/IndustryAsDelegate"));
const Delegate = lazy(() => import(/* webpackChunkName: "delegate" */ "./Reg-Routes/Delegate"));
const Staff = lazy(() => import(/* webpackChunkName: "staff" */ "./Reg-Routes/Staff"));
const Travels = lazy(() => import(/* webpackChunkName: "travels" */ "./Travels/Travels"));
const OfficeBearers = lazy(() => import(/* webpackChunkName: "office-bearers" */ "./OfficeBearers/OfficeBearers"));
const VerifyRegistration = lazy(() => import(/* webpackChunkName: "verify-registration" */ "./VerifyRegistration/VerifyRegistration"));
const InternationalRegistrations = lazy(() => import(/* webpackChunkName: "registration-international" */ "./Reg-Routes/InternationalRegistrations"));
const Trip = lazy(() => import(/* webpackChunkName: "trip" */ "./Trip/Trip"));
const PrivacyPolicy = lazy(() => import(/* webpackChunkName: "privacy-policy" */ "./Policy/PrivacyPolicy"));
const Workshop = lazy(() => import(/* webpackChunkName: "workshop" */ "./Workshop/Workshop.js"));

const theme = createTheme({
  palette: {
    primary: {
      main: "#01639c",
    },
    secondary: {
      main: "#ffff",
    },
  },
  typography: {
    fontFamily: "Outfit, sans-serif",
  },
});

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.customHistory = createBrowserHistory();
  }

  componentDidMount() {
    ReactGA.initialize("G-2VPEFG8BGY");
  }

  render = () => {
    return (
      <ThemeProvider theme={theme}>
        <Router history={this.customHistory}>
          <Suspense
            fallback={
              <div className="loader-container">
                <Loader />
              </div>
            }>
            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/committee/:name" component={Team} />
              <Route path="/office-bearers/:name" component={OfficeBearers} />
              <Route path="/faculty/" component={Faculty} />
              <Route path="/partners" component={Partners} />
              <Route exact path="/abstract" component={AbstractClosed} />
              <Route path="/abstract/form" component={AbstractForm} />
              <Route path="/scientific-program" component={ScientificProgram} />
              <Route path="/workshop" component={Workshop} />
              <Route path="/contact" component={Contact} />
              <Route exact path="/registration" component={Registration} />
              <Route exact path="/registration/form" component={Delegate} />
              <Route exact path="/registration/international" component={InternationalRegistrations} />
              <Route exact path="/registration/staff-form" component={Staff} />
              <Route exact path="/registration/industry-form/:id" component={Industry} />
              <Route exact path="/registration/industry-as-delegate" component={IndustryAsDelegate} />
              <Route path="/nearby-places" component={NearbyPlaces} />
              <Route path="/order-success" component={OrderSuccess} />
              <Route path="/order-failed" component={OrderFail} />
              <Route path="/trip-ayo" component={Trip} />
              <Route path="/travel-and-accomodation" component={Travels} />
              <Route path="/delegate/:delegateID" component={VerifyRegistration} />
              <Route path="/privacy-policy" component={PrivacyPolicy} />
              <Route component={PageMiss} />
            </Switch>
          </Suspense>
        </Router>
      </ThemeProvider>
    );
  };
}

export default App;